import React from "react";
import PropTypes from "kf-proptypes/widgets";
import { Skeleton as AntSkeleton } from "antd";

import "antd/es/skeleton/style/css";

export function Skeleton({
  children,
  active = true,
  avatar = false,
  loading,
  paragraph,
  round,
  title,
  className,
  type
}) {
  switch (type) {
    case "image": {
      return <AntSkeleton.Image active />;
    }
    default: {
      return (
        <AntSkeleton
          active={active}
          avatar={avatar}
          loading={loading}
          paragraph={paragraph}
          round={round}
          title={title}
          className={className}
        >
          {children}
        </AntSkeleton>
      );
    }
  }
}

Skeleton.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  avatar: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ shape: PropTypes.string, size: PropTypes.number })
  ]),
  loading: PropTypes.bool,
  paragraph: PropTypes.shape({
    rows: PropTypes.number,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  round: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  rows: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  type: PropTypes.string
};
